














import { Component, Vue } from 'vue-property-decorator';
import {saveAs} from 'file-saver';

import Layout from '@/layouts/Default.vue';
import ListBlock from '@/views/CRUD/List.vue';

import PaymentsModule from '@/store/payments';
import ResponseHandlerModule from "@/store/modules/responseHandler";
import axios from 'axios';
import userModule from '@/store/user';

@Component({
  components: {
    Layout,
    ListBlock,
  }
})
export default class PaymentsPage extends Vue {
  repository = PaymentsModule;

  get filterSettings() {
    return PaymentsModule.filter.filterSettings;
  }

  async updateList() {
    await this.repository.filter.updateFilter();
    await this.repository.updatePage('1');
  }

  async resetFilters() {
    await this.repository.clearSort();
    await this.repository.filter.resetFilter();
    await this.repository.updatePage('1');
  }

  toExport() {
    const params = this.repository.filter.filterSettings.filter.slice(1);

    axios
        .get(`api/payments/export?${params}`, {
          responseType: 'blob',
          headers: {
            Authorization: `Bearer ${userModule.token}`,
          },
        })
        .then(response => {
          saveAs(response.data, 'export.xlsx');
        })
        .catch(error => ResponseHandlerModule.showNotify({ message: error.message, type: 'fail' }))
  }
}
